import React, {useReducer, useEffect} from 'react'

import MinusIcon from '../icons/minus.svg';
import PlusIcon from '../icons/plus.svg';

const reducer = (state, action) => {
  switch (action.type) {
    case 'increment':
      return state + 1;
    case 'decrement':
      return state - 1;
    default:
      throw new Error();
  }
}

const NumberInput = (props) => {
  const {onChange, value} = props
  const [state, dispatch] = useReducer(reducer, value)

  useEffect(()=>{
    if (onChange) {
      onChange(state)
    }
  }, [state, onChange])

  return (
    <div className="pwa__numberInput">
      <button type="button" className="button minus primary" onClick={() => dispatch({type: 'decrement'})} disabled={state==1}>
        <MinusIcon/>
      </button>
      <input readOnly
             value={state} 
      />
      <button type="button" className="button plus primary" onClick={() => dispatch({type: 'increment'})}>
        <PlusIcon/>
      </button>
    </div>  
  )
}

export default NumberInput
